import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const KEY = "scu_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = useCallback((item) => {
    setItems((prev) => {
      const ex = prev.find((p) => p.item_id === item.item_id);
      if (ex) return prev.map((p) => p.item_id === item.item_id ? { ...p, quantity: p.quantity + 1 } : p);
      return [...prev, { ...item, quantity: 1 }];
    });
  }, []);

  const remove = useCallback((item_id) => setItems((prev) => prev.filter((p) => p.item_id !== item_id)), []);
  const updateQty = useCallback((item_id, q) => setItems((prev) =>
    prev.map((p) => p.item_id === item_id ? { ...p, quantity: Math.max(1, q) } : p)
  ), []);
  const clear = useCallback(() => setItems([]), []);

  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  const value = useMemo(
    () => ({ items, add, remove, updateQty, clear, total, count }),
    [items, add, remove, updateQty, clear, total, count]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);
